/*******************************************************************************
    plik  : frontend/src/components/Footer.tsx
    autor : Michal Kolodziejski (2:480/112.10)
    data  : 2025.01.06
    copyright  : PTODT <https://ptodt.org.pl>

    opis  : Application footer component

    licencja : MIT
*******************************************************************************/

import React from 'react';

/**
 * @brief Application footer with copyright and links
 * @return Footer JSX element
 */
const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer" role="contentinfo">
            <div className="footer__container">
                <div className="footer__author">
                    <pre className="footer__ascii-art" aria-hidden="true">{`  CODE BY
  ----.-.---.---.---.
      |-.---.   |--.|#==---.. .  .  .
   |  | |   | --.   |#==---. . .
  -'--'-'---'---'---'               ${currentYear}.01`}</pre>
                    <p className="footer__author-name">
                        Michal Kolodziejski (2:480/112.10)
                    </p>
                </div>

                <p className="footer__copyright">
                    &copy; {currentYear}{' '}
                    <a
                        href="https://ptodt.org.pl"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        PTODT
                    </a>
                </p>

                <p className="footer__motto">
                    <em>"Didn't like it? Mind your own values."</em>
                </p>

                <nav className="footer__nav" aria-label="Nawigacja stopki">
                    <ul className="footer__nav-list">
                        <li>
                            <a
                                href="https://github.com/ptodt"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                GitHub
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://ptodt.org.pl/kontakt"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Kontakt
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
